export default __webpack_public_path__ + "static/media/ic2.5a1c3f99.jpg";